"use client";

import { motion, AnimatePresence } from "motion/react";
import { Loader2 } from "lucide-react";

export default function CartLoader({ isLoading }: { isLoading: boolean }) {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/60 backdrop-blur-[2px]"
        >
          <div className="relative flex items-center justify-center">
            {/* Outer Spinning Ring */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
              className="w-20 h-20 rounded-full border-[3px] border-orange-100 border-t-orange-500 shadow-lg shadow-orange-500/10"
            />
            
            {/* Inner Static Icon */}
            <div className="absolute">
              <Loader2 className="w-8 h-8 text-orange-500 animate-spin-slow opacity-80" />
            </div>
          </div>
          
          <motion.div
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mt-6 flex flex-col items-center gap-1"
          >
            <p className="text-sm font-black text-gray-900 uppercase tracking-[0.3em]">Processing</p>
            <div className="flex gap-1">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  animate={{ opacity: [0.3, 1, 0.3] }}
                  transition={{ duration: 1, repeat: Infinity, delay: i * 0.2 }}
                  className="w-1 h-1 rounded-full bg-orange-400"
                />
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
